import BurggerButton from 'components/home/navbar/buttons/burgger-button';
import CultureShow from 'core/culture-show';
import fontStyles from 'styles/Fonts.module.scss';
import Hide from 'core/hide';
import Image from 'core/image';
import { Logo } from 'components/home/navbar/logo/logo';
import MyAcountButton from 'components/home/navbar/buttons/my-acount-button';
import phoneIcon from 'static/img/icons/phone-icon.svg';
import styles from 'styles/Header.module.scss';
import { TransparentButton } from 'core/buttons/buttons';
import { useScroll } from 'hooks';
import { useState } from 'react';
import { useTranslations } from 'next-intl';

const KeypadHome = () => {
    const t = useTranslations('header.keypad');
    const [display, setDisplay] = useState('');

    useScroll((scroll) => {
        setDisplay(scroll > 100 ? 'none' : '');
    }, []);

    const handleClick = () => {
        const elm = document.getElementById('faq');
        if (elm?.scrollIntoView) {
            elm.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <>
            <div className={styles.sHeaderNavbarRowCol}>
                <Logo />
            </div>
            <div className={styles.sHeaderNavbarRowCol}>
                <div className={styles.keypad}>
                    {display !== 'none' && <BurggerButton />}
                    <div
                        style={{
                            marginLeft: '2%',
                            marginRight: '2%',
                            display
                        }}
                    >
                        <Hide md>
                            <TransparentButton
                                label={t('help-button.text')}
                                compact
                                onClick={handleClick}
                            />
                        </Hide>
                    </div>

                    <CultureShow cultures={['es-ar']}>
                        <div style={{ marginLeft: '2%', display }}>
                            <Hide md>
                                <TransparentButton
                                    label={t('my-policy.text')}
                                    compact={true}
                                    href={t('my-policy.link')}
                                />
                            </Hide>
                        </div>
                    </CultureShow>

                    <CultureShow cultures={['es-ar']}>
                        <div style={{ marginLeft: '2%', display }}>
                            <MyAcountButton buttonType="home" />
                        </div>
                    </CultureShow>

                    <CultureShow cultures={['es-ar', 'es-mx', 'pt-br']}>
                        <a
                            className={styles.phone_container}
                            href={t('phone.link')}
                            style={{ display }}
                        >
                            <Image
                                src={phoneIcon}
                                width={25}
                                height={20}
                                alt={t('phone.text')}
                            />
                            <span className={fontStyles.text_header4}>
                                {' '}{t('phone.text')}
                            </span>
                            <p className={fontStyles.text_small}>
                                {t('phone.description')}
                            </p>
                        </a>
                    </CultureShow>
                </div>
            </div>
        </>
    );
};

export default KeypadHome;
